const profanity = require('profanity-util');

const purifyProfanity = (string) => {
  return profanity.purify(string, { replace: true, map: true, substrings: true });
};

const hasProfanity = (string) => {
  return profanity.check(string, { substrings: true }).length > 0;
};

module.exports = { purifyProfanity, hasProfanity };
